<template>
  <div class="p-learning-result">
    <div class="p-learning-result__head">
      <div class="p-learning-result__head__inner">
        <div class="question c-markdown-area c-markdown-area--imageSizeRestricted">
          <question-text-view :rawText="title" :prefix="prefix" :work-id="workId"></question-text-view>
        </div>
        <div class="viewLink">
          <a
            target="_blank"
            :href="progressStatus.question_url"
          >問題を見る
          </a>
          <a
            target="_blank"
            :href="progressStatus.answer_url"
          >解答・解説を見る
          </a>
        </div>
      </div>
    </div>
    <div class="p-learning-result__body">
      <div class="p-learning-result__body__inner">
        <ul class="guide">
          <li class="item item--color5">初回学習で正答</li>
          <li class="item item--color6">初回学習で誤答／復習で正答</li>
          <li class="item item--color7">未正解</li>
          <li class="item item--color8">未学習</li>
        </ul>
      </div>
      <div class="c-parts-toggle__wrapper">
        <p class="c-parts-toggle__text">表示切替</p>
        <div class="c-parts-toggle" :class="{'c-parts-toggle--active': isLatest}" @click="toggleDisplayLatest">
          <span class="label">{{ isLatest ? '最新の解答' : '初回の解答' }}</span>
          <span class="toggle"></span>
        </div>
      </div>
    </div>
    <div class="c-table-fixed-header-footer-wrapper">
      <table class="c-table-fixed-header-footer -progress">
        <thead>
          <tr>
            <th class="id"><div class="spacer">出席番号</div></th>
            <th class="name">名前</th>
            <th
              v-for="(header, index) in progressStatus.headers_and_footers"
              :key="index"
              class="answer"
            >解答欄（{{ header.title }}）</th>
            <th data-copy-ignore><div class="spacer"></div></th>
          </tr>
        </thead>

        <!-- 最新解答時 -->
        <tbody v-show="isLatest">
          <tr
            v-for="student in progressStatus.students"
            :key="`${student.name}-${student.number}`"
          >
            <th>{{ student.number }}</th>
            <th>{{ student.name }}</th>
            <td
              v-for="quiz in student.quizzes"
              :key="quiz.id"
              :class="celColorMap[quiz.answer_statuses.latest.correct_answer]"
            >
              <student-answer-view
                :answer="quiz.answer_statuses.latest.answer"
                :answer-format="quiz.answer_format"
                :subject-field="subjectField"
              />
            </td>
            <td></td>
          </tr>
        </tbody>

        <!-- 初回解答時 -->
        <tbody v-show="!isLatest">
          <tr
            v-for="student in progressStatus.students"
            :key="`${student.name}-${student.number}`"
          >
            <th>{{ student.number }}</th>
            <th>{{ student.name }}</th>
            <td
              v-for="quiz in student.quizzes"
              :key="quiz.id"
              :class="celColorMap[quiz.answer_statuses.initial.correct_answer]"
            >
              <student-answer-view
                :answer="quiz.answer_statuses.initial.answer"
                :answer-format="quiz.answer_format"
                :subject-field="subjectField"
              />
            </td>
            <td></td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <th colspan="2">正答</th>
            <question-correct-answer v-for="(footer, index) in progressStatus.headers_and_footers"
              :key="index"
              :answer-format="footer.answer_format"
              :choices-label="footer.choices_label"
              :correct-answers="footer.answers"
            ></question-correct-answer>
            <td></td>
          </tr>
          <tr>
            <th colspan="2">初回正答率</th>
            <td
              v-for="(footer, index) in progressStatus.headers_and_footers"
              :key="index"
            >{{ footer.correct_answer_rate_initial }}%</td>
            <td></td>
          </tr>
          <tr>
            <th colspan="2">平均正答率</th>
            <td
              v-for="(footer, index) in progressStatus.headers_and_footers"
              :key="index"
            >{{ footer.correct_answer_rate_latest }}%</td>
            <td></td>
          </tr>
          <tr data-copy-ignore>
            <th colspan="2"><div class="spacer"></div></th>
            <th
              v-for="numberOfQuiz in numberOfQuizzes"
              :key="numberOfQuiz"
            ></th>
            <td></td>
            <th><div class="spacer"></div></th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed} from "vue";

  // FIXME: 生徒一覧の v-for の key は backend から user.uuid か student.id を返してもらうのが良さそう
  const props = defineProps<{
    workId: number
    title: string
    prefix: string
    progressStatus: any
    /** StudentAnswerView に渡す教科分野識別子（"rika" 形式）。理科の場合に文字列置換処理が行われる。 */
    subjectField: string
  }>()

  // cf. teacher_learning_progress.consts.CorrectAnswer
  const celColorMap: { [answerStatus: number] : string } = {
    1: "celColor1",
    2: "celColor2",
    3: "celColor3",
    4: "",  // 未学習はデフォルトのセル色
  }

  const isLatest = ref(true)

  const numberOfQuizzes = computed(() => {
    return props.progressStatus.headers_and_footers.length
  })

  function toggleDisplayLatest() {
    isLatest.value = !isLatest.value
  }
</script>

<style lang="scss" scoped>
</style>
